<template>
  <p v-if="notification.notificationType === 'Praise'">
    "{{ notification.body.rootElement.TutorEmail }}" praised your
    <router-link
      :to="
        recordingHighlightUrl(
          notification.body.rootElement.BookId,
          notification.body.rootElement.SectionNumber,
          notification.body.rootElement.RecordingGuid
        )
      "
    >
      recording
    </router-link>
  </p>
  <p v-else-if="notification.notificationType === 'Feedback'">
    "{{ notification.body.rootElement.TutorEmail }}" left feedback on your
    <router-link
      :to="
        recordingHighlightUrl(
          notification.body.rootElement.BookId,
          notification.body.rootElement.SectionNumber,
          notification.body.rootElement.RecordingGuid
        )
      "
    >
      recording
    </router-link>
  </p>
  <p v-else-if="notification.notificationType === 'SharedRecording'">
    "{{ notification.body.rootElement.StudentEmail }}" has shared a recording
    with you.
    <router-link
      :to="studentRecordingsUrl(notification.body.rootElement.StudentGuid)"
    >
      See their recordings
    </router-link>
  </p>
</template>

<script>
export default {
  props: ["notification"],
  methods: {
    recordingHighlightUrl(bookId, sectionNumber, recordingGuid) {
      return `/library/${bookId}/sections/${sectionNumber}?mode=r&recording=${recordingGuid}`;
    },
    studentRecordingsUrl(studentGuid) {
      return `/students/${studentGuid}/recordings`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
